import { company_name } from "@/i18n/variables";

const entities = {
	backups: {
		default: "Standard-Backups",
		extra: "Zusätzliche Backups",
		title: "Backups",
	},
	cpu: {
		assigned: "Zugewiesen",
		title: "CPU",
		usage: "In Verwendung",
	},
	extra_storage: {
		bulk: {
			title: "Massenspeicher (HDD)",
		},
		default: {
			title: "Speicher (SSD)",
		},
	},
	ip_config: {
		ipv4: "IPv4-Adresse",
		ipv6: "IPv6-Adresse",
		title: "IP-Adressen",
	},
	login: {
		info: "Das folgende Passwort ist das Passwort, das bei der Bereitstellung des VPS festgelegt wurde. Bewahren Sie es gut auf, da es nur während der ersten <strong>31 Tage</strong> nach der Bereitstellung angezeigt wird.",
		password: {
			expired: "Abgelaufen",
			expired_tooltip: `Das bei der Bereitstellung des VPS festgelegte Passwort wird hier nur während der ersten <strong>31 Tage</strong> nach der Bereitstellung angezeigt, um Desinformationen zu verhindern. Wenn Sie Ihr Passwort nicht gespeichert haben, können Sie sich an ${company_name} wenden.`,
			title: "Passwort",
			tooltip:
				"Dies ist das Passwort, das bei der Bereitstellung des VPS festgelegt wurde. Bewahren Sie es gut auf, da es nur während der ersten <strong>31 Tage</strong> nach der Bereitstellung angezeigt wird.",
		},
		title: "Anmelden",
		username: "Benutzername",
	},
	memory: {
		assigned: "Zugewiesen",
		title: "Arbeitsspeicher",
		usage: "In Verwendung",
	},
	nameservers: {
		ns1_ipv4: "Nameserver 1 (IPv4)",
		ns1_ipv6: "Nameserver 1 (IPv6)",
		ns1_nat64: "Nameserver 1 (Nat64)",
		ns2_ipv4: "Nameserver 2 (IPv4)",
		ns2_ipv6: "Nameserver 2 (IPv6)",
		title: "Nameserver",
	},
	private_network: {
		title: "Privates Netzwerk",
	},
	server_location: {
		title: "Serverstandort",
	},
	sla: {
		sla_level: {
			level_0: "Stufe 0",
			level_1: "Stufe 1",
			level_2: "Stufe 2",
			none: "Keine SLA",
		},
		title: "Service Level Agreement",
	},
	snapshots: {
		title: "Snapshots",
	},
	storage: {
		title: "Speicher (SSD)",
	},
};

export default entities;
